import { Directive, Input, NgZone, TemplateRef, ViewContainerRef } from '@angular/core';

@Directive({
    selector: '[anjTemplate]'
})
export class TemplateDirective {

    @Input()
    set anjTemplateOf(name: string) {
        this._name = name;
    }
    get name(): string {
        return this._name;
    }

    get template(): TemplateRef<any> {
        return this._template;
    }

    get viewContainerRef(): ViewContainerRef {
        return this._viewRef;
    }

    get zone(): NgZone {
        return this._zone;
    }

    private _name: string;

    constructor(private _template: TemplateRef<any>, private _viewRef: ViewContainerRef, private _zone: NgZone) {}
}
